export default __webpack_public_path__ + "img/tiny-21.c2959498.jpg";